import React, {Component} from 'react'
import HttpRequest from "../../../HttpRequest";
import Route, {default as Links} from "../../../Route";
import Components from "../../../components";
import {Tools} from "../../../Tools";


// Import React FilePond
import { FilePond, registerPlugin } from "react-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import MessageBuilder from "../../../components/MessageBuilder";
import Loader from "../../../components/Loader";
import ErrorPage from "../../../components/ErrorPage";
import $ from "../../../components/ExternalLibs/jquery";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);


const
    avatar_component = "avatar",
    formFields = {
        avatar: "",
        name: "",
        firstName: "",
        email: "",
        city: "",
        countryResidence: "",
        profession: "",
        phone: "",
        civility: "",
        cycle: "",
        promotion: "",
        workPlace: "",
        function: "",
        hasFinishedCycle: false,
    },
    disabledAttribute = {
        disabled: "disabled",
    },
    addButtons = {
        id: "",
        set: {
            label: "Enrégistrer",
            action: "POST",
            attributes: disabledAttribute,
        }
    },
    loadingInButton = (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>Waiting...</>),
    fieldsToActiveSubmitButton = ["acceptTermsMembership", "acceptPreviousRegulation"]
    ;

class EditMember extends Component {
    constructor(props){
        super(props);
        this.handleButtonClicked = this.handleButtonClicked.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.httpClient = new HttpRequest();
        this.oldAvatar = null;
        this.formRef = React.createRef();
        this.counterRef = React.createRef();

        this.server = {};

        this.state = {
            server: {},
            isLoadCompleted: false,
            memberUpdated: false,
            hasFormError: false,
            hasError: false,
            showAlert: false,
            form: {
                fieldValues: Tools.Clone(formFields),
                fieldLabels: Tools.Clone(formFields),
                buttons: Tools.Clone(addButtons),
            },

            civilities: [],
            cycles: [],
            promotions: [],
            countries: [],
            professions: [],
            // Set initial files, type 'local' means this is a file
            // that has already been uploaded to the server (see docs)
            files: []
        };
        this.alertRef = React.createRef();
    }


    handleChange(field, event){
        let form = this.state.form, value = event.target.value;
        if(typeof form.fieldValues[field] === "boolean"){
            value = !form.fieldValues[field];
        }
        form.fieldValues[field] = value;

        form.buttons["set"].attributes = null;
        this.setState({form: form});
    }

    handleInit() {}

    handleButtonClicked(event){
        // Here we add the loader in the button
        let form = this.state.form, newButtonLoader = Tools.Clone(addButtons);
        newButtonLoader["set"].label = loadingInButton;
        newButtonLoader["set"].attributes = disabledAttribute;
        form.buttons = newButtonLoader;
        this.setState({form: form});

        let data = {...this.state.form.fieldValues,};

        // Call to the API
        const _self = this;
        this.httpClient.request(Links.APIMembers, "PUT", {}, data).then(function (response){
            _self.server = response;
            let state = {server: response, form: form, showAlert: true, hasAsyncError: false};
            if(_self.server.code === 200){
                // We reset form
                form.fieldValues = Tools.Clone(formFields);
                state = {memberUpdated: true, files: [], form: form};
            }
            state.hasFormError = !(_self.server.code === 200);

            form.buttons = addButtons;
            form.buttons.set.attributes = null;
            _self.setState({...state});
        }).catch(function (error){
            _self.server = error;
            form.buttons = addButtons;
            form.buttons.set.attributes = null;
            _self.setState({server: error, form: form, showAlert: true, hasAsyncError: true});
        });
    }
    handleSubmit(event){
        event.preventDefault();
    }

    render() {
        const state = this.state;

        if(Tools.IsEmpty(this.civilityOptions)){
            this.civilityOptions = state.civilities.map((item) => {
                return <Components.Option key={"civilities-" + item.id} data={{
                    value: item.id,
                    label: item.label,
                }} />
            });
        }
        if(Tools.IsEmpty(this.professionOptions)){
            this.professionOptions = state.professions.map((item) => {
                return <Components.Option key={"professions-" + item.id} data={{
                    value: item.id,
                    label: item.label,
                }} />
            });
        }
        if(Tools.IsEmpty(this.countryOptions)){
            this.countryOptions = state.countries.map((item) => {
                return <Components.Option key={"countries-" + item.id} data={{
                    value: item.id,
                    label: item.label,
                }} />
            });
        }
        if(Tools.IsEmpty(this.promotionOptions)){
            this.promotionOptions = state.promotions.map((item) => {
                return <Components.Option key={"promotions-" + item.id} data={{
                    value: item.id,
                    label: item.label,
                }} />
            });
        }
        if(Tools.IsEmpty(this.cycleOptions)){
            this.cycleOptions = state.cycles.map((item) => {
                return <Components.Option key={"cycles-" + item.id} data={{
                    value: item.id,
                    label: item.label,
                }} />
            });
        }
        let fieldLabels = Tools.Clone(this.state.form.fieldLabels);
        Object.keys(fieldLabels).forEach((key) => {
            if(state.member_register_form && state.member_register_form.hasOwnProperty(key)){
                const field = state.member_register_form[key];
                fieldLabels[key] = field.label + (field.require === true && key !== "acceptTermsMembership" && key !== "acceptPreviousRegulation" ? " *" : "");
            }
        });

        let messageElement = "";
        if(state.showAlert || state.memberUpdated){
            let content = null,
                messageBuilder = MessageBuilder.create(),
                alertClass = Components.Dialogs.ALERT_TYPES.DANGER;

            if(state.hasAsyncError){
                content = "Nos serveurs sont en maintenance. Revenez ultérieurement!";
            }
            else{
                if(this.server.data && this.server.data.hasOwnProperty("fields_error")){
                    Object.keys(this.server.data.fields_error).forEach((field) => {
                        messageBuilder.addMessage(this.server.data.fields_error[field].label);
                    });
                    content = messageBuilder.getMessage();
                }
                if(!content && this.server.message){
                    content = this.server.message;
                }
                if(state.memberUpdated){
                    this.formRef.current.classList.add("hidden");
                    alertClass = Components.Dialogs.ALERT_TYPES.SUCCESS;
                    content += '<div><strong>Vous allez être redirigé dans <span id="counter" data-counter="5">5</span> secondes.</strong></div>';
                }
            }
            messageElement = <Components.Dialogs.AlertDialog  data={{ref: this.alertRef, content: content, iconClass: "", alertClass: alertClass}} />;
        }


        let element;
        if(!state.isLoadCompleted){
            element = <Loader />;
        }
        else if(state.hasError){
            const text = state.server && state.server.message ? "<h1>"+ state.server.message +"</h1>" : "";
            element = <ErrorPage data={{content: text}} />;
        }
        else{
            element = (
                <div className="row">
                    <div className="col-md-2"></div>
                    <div className="col-md-8" ref={this.counterRef}>
                        {messageElement}
                        {
                            state.memberUpdated ?
                                ""
                                :
                                <form ref={this.formRef} onSubmit={this.handleSubmit} encType="multipart/form-data">
                                    <div className="row container-info">Les champs marqués avec le signe (*) sont obligatoires</div>

                                    <fieldset className="join-fieldset">
                                        <legend>Informations personnelles</legend>
                                        <div className="row mb-3">
                                            <div className="col-md-4"></div>
                                            <div className="col-md-4 mb-3 thumbnail align-center">
                                                <label>Photo * :</label>
                                                <FilePond
                                                    ref={ref => (this.pond = ref)}
                                                    files={this.state.files}
                                                    allowMultiple={false}
                                                    maxFiles={1}
                                                    server={
                                                        {
                                                            url: Links.APIBaseUrl,
                                                            process: {
                                                                url: Links.APIUploadMemberFile,
                                                                method: "POST",
                                                                ondata: (formData) => {
                                                                    formData.append("field_name", avatar_component);
                                                                    return formData;
                                                                },
                                                            },
                                                            load: Links.APILoadMemberFile,
                                                        }
                                                    }
                                                    name={avatar_component} /* sets the file input name, it's filepond by default */
                                                    onupdatefiles={fileItems => {
                                                        const files = fileItems.map(fileItem => fileItem.file);
                                                        // Set currently active file objects to this.state
                                                        this.setState({
                                                            files: files
                                                        });
                                                    }}
                                                    onprocessfile={(error, file) => {
                                                        if(error){
                                                            console.log(error)
                                                        }
                                                        else{
                                                            if(file.serverId){
                                                                const response = HttpRequest.parseRequestResponse(file.serverId);
                                                                if(response.code === 200){
                                                                    let form = this.state.form;
                                                                    this.oldAvatar = form.fieldValues["avatar"];
                                                                    form.fieldValues["avatar"] = response.data[avatar_component + "_reference"];
                                                                    this.setState({form: form});
                                                                }
                                                            }
                                                        }
                                                    }}
                                                    onremovefile={(error, file) => {
                                                        if(this.oldAvatar){
                                                            let form = this.state.form;
                                                            form.fieldValues["avatar"] = this.oldAvatar;
                                                            this.setState({form: form});
                                                        }
                                                    }}
                                                />
                                                Selectionnez votre photo
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="civility">{fieldLabels.civility}</label>
                                                <select id="civility" name="civility" className="form-control input-civility input-lg" required onChange={this.handleChange.bind(this, "civility")} value={this.state.form.fieldValues.civility}>
                                                    {this.civilityOptions}
                                                </select>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="name">{fieldLabels.name}</label>
                                                <input id="name" className="form-control input-name input-lg" type="text" name="name"
                                                       required onChange={this.handleChange.bind(this, "name")} value={this.state.form.fieldValues.name} />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="firstName">{fieldLabels.firstName}</label>
                                                <input id="firstName" className="form-control input-firstName input-lg" type="text" name="firstName"
                                                       required onChange={this.handleChange.bind(this, "firstName")} value={this.state.form.fieldValues.firstName} />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="phone">{fieldLabels.phone}</label>
                                                <input id="phone" className="form-control input-phone input-lg" type="text" name="phone" onChange={this.handleChange.bind(this, "phone")} value={this.state.form.fieldValues.phone} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="countryResidence">{fieldLabels.countryResidence}</label>
                                                <select id="countryResidence" name="countryResidence" className="form-control input-countryResidence input-lg" required onChange={this.handleChange.bind(this, "countryResidence")} value={this.state.form.fieldValues.countryResidence}>
                                                    {this.countryOptions}
                                                </select>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="city">{fieldLabels.city}</label>
                                                <input id="city" className="form-control input-city input-lg" type="text" name="city" required onChange={this.handleChange.bind(this, "city")} value={this.state.form.fieldValues.city}/>
                                            </div>
                                        </div>
                                    </fieldset>

                                    <fieldset className="join-fieldset">
                                        <legend>Qualification</legend>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="profession">{fieldLabels.profession}</label>
                                                <select id="profession" name="profession" className="form-control input-profession input-lg" required onChange={this.handleChange.bind(this, "profession")} value={this.state.form.fieldValues.profession}>
                                                    {this.professionOptions}
                                                </select>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="function">{fieldLabels.function}</label>
                                                <input id="function" className="form-control input-phone input-lg" placeholder="Ex: DSI, Directeur, Chef de service, Collaborateur, etc" type="text" name="phone" onChange={this.handleChange.bind(this, "function")} value={this.state.form.fieldValues.function} />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="workPlace">{fieldLabels.workPlace}</label>
                                                <input id="workPlace" className="form-control input-phone input-lg" type="text" name="phone" onChange={this.handleChange.bind(this, "workPlace")} value={this.state.form.fieldValues.workPlace} />
                                            </div>
                                        </div>
                                    </fieldset>

                                    <fieldset className="join-fieldset">
                                        <legend>Parcours</legend>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="promotion">{fieldLabels.promotion}</label>
                                                <select id="promotion" name="promotion" className="form-control input-promotion input-lg" required onChange={this.handleChange.bind(this, "promotion")} value={this.state.form.fieldValues.promotion}>
                                                    {this.promotionOptions}
                                                </select>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="cycle">{fieldLabels.cycle}</label>
                                                <select id="cycle" name="countryResidence" className="form-control input-countryResidence input-lg" required onChange={this.handleChange.bind(this, "cycle")} value={this.state.form.fieldValues.cycle}>
                                                    {this.cycleOptions}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <div className="join-consent-checkbox">
                                                    <input id="hasFinishedCycle" className="" type="checkbox" name="hasFinishedCycle" onChange={this.handleChange.bind(this, "hasFinishedCycle")} defaultChecked={this.state.form.fieldValues.hasFinishedCycle}/>
                                                    <label htmlFor="hasFinishedCycle">{fieldLabels.hasFinishedCycle}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <button className="btn btn-primary btn-lg btn-block" type="submit" {...this.state.form.buttons.set.attributes} onClick={this.handleButtonClicked} data-id={this.state.form.buttons.id} data-action={this.state.form.buttons.set.action}>{this.state.form.buttons.set.label}</button>
                                </form>
                        }
                    </div>
                </div>
            );
        }

        return element;
    }

    componentDidMount() {
        const _self = this;
        this.httpClient.request(Links.APIMembersEditFormData, "GET").then(function (response){
            _self.server = response;

            const fieldValues = {};
            Object.keys(_self.state.form.fieldValues).forEach((field) => {
                fieldValues[field] = _self.state.form.fieldValues[field];
                if(response.data.member[field] || typeof response.data.member[field] == "boolean"){
                    fieldValues[field] = response.data.member[field];
                }
            })

            const form = _self.state.form;
            form.fieldValues = fieldValues;

            let files = _self.files;
            if(response.data.member.avatar){
                files = [{source: response.data.member.avatar, options: {type: "local"}}];
            }

           _self.setState({isLoadCompleted: true, ...form, files: files, ...response.data});

        }).catch(function (error){
            _self.setState({showAlert: true, hasAsyncError: true, isLoadCompleted: true});
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if(this.state.hasFormError !== prevState.hasFormError){
            if(this.alertRef.current && !this.state.memberUpdated){
                const root = $('html, body');
                root.animate({
                    scrollTop: root.offset().top
                }, 'slow');
            }
        }

        if(this.state.memberUpdated !== prevState.memberUpdated && this.counterRef.current){
            const counter = this.counterRef.current.querySelector("#counter");
            if(counter){
                const intervalID = setInterval(() => {
                    let count = parseInt(counter.getAttribute("data-counter"));
                    count = count > 0 ? count - 1 : 0;

                    counter.setAttribute("data-counter", count + "");
                    counter.innerHTML = count + "";

                    if(count === 0){
                        window.location.reload();
                        clearInterval(intervalID);
                    }
                }, 1000);
            }
        }
    }
}
export default EditMember;